import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import TagService from "../../../Services/Tag.service";
const makeSearchArgs = {
    loadOptions: (query, options) => { var _a; return TagService.search(query, (_a = options.max) !== null && _a !== void 0 ? _a : 20, options.includeSystemTags); },
    value: "id",
    label: "name",
};
export const TagSearch = makeSearch(makeSearchArgs);
export const TagMultiSearch = makeMultiSearch(makeSearchArgs);
